import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { commonApi } from 'core/api/common.api';
import { setAxiosAuth } from 'utils';

export const useGetLoadPortal = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.loadPortal],
    queryFn: async () => await commonApi.loadPortal({}),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken),
  });
};
